import type { RouteRecordRaw } from 'vue-router'

const investigationReportsRoutes: RouteRecordRaw[] = [
  {
    path: '/investigation-reports',
    name: 'investigation-reports.index',
    component: () => import('@/modules/qrf/views/InvestigationReportsIndex.vue'),
    meta: {
      pageTitle: 'Investigation reports',
      breadcrumbs: ['Investigation reports']
    }
  },
  {
    path: '/investigation-reports/:id',
    name: 'investigation-reports.show',
    component: () => import('@/modules/qrf/views/InvestigationReportsShow.vue'),
    meta: {
      pageTitle: 'Investigation reports',
      breadcrumbs: ['Investigation reports']
    }
  },
  {
    path: '/investigation-reports/create',
    name: 'investigation-reports.create',
    component: () => import('@/modules/qrf/views/InvestigationReportsEdit.vue'),
    meta: {
      pageTitle: 'Investigation reports',
      breadcrumbs: ['Investigation reports']
    }
  },
  {
    path: '/investigation-reports/:id/edit',
    name: 'investigation-reports.edit',
    component: () => import('@/modules/qrf/views/InvestigationReportsEdit.vue'),
    meta: {
      pageTitle: 'Investigation reports',
      breadcrumbs: ['Investigation reports']
    }
  }
]

export default investigationReportsRoutes
